/* eslint-disable no-param-reassign */
export default (state) => {
  state.inProgressTrayInstance = { instance: undefined, loading: false, success: false };
};
